import React from 'react';
import { Input } from 'antd';
import { Dictionary } from '@onaio/utils/dist/types/types';

interface UserFilterInputProps {
  users: Dictionary[];
  onFilter: (filteredUsers: Dictionary[]) => void;
  placeholder?: string;
}

const UserFilterInput: React.FC<UserFilterInputProps> = ({ users, onFilter, placeholder }) => {

  const handleSearch = (value: string) => {
    const searchTerm = value.toLowerCase().trim();
    if (!searchTerm) {
      onFilter(users);
      return;
    }

    const filtered = users.filter(user => {
      const nameMatch = user.name?.toLowerCase().includes(searchTerm);
      const emailMatch = user.email?.toLowerCase().includes(searchTerm);
      return nameMatch || emailMatch;
    });

    onFilter(filtered);
  };

  return (
    <Input.Search
      placeholder={placeholder || "Search users by name or email..."}
      onSearch={handleSearch}
      onChange={(e) => handleSearch(e.target.value)}
      allowClear
      style={{ width: '100%' }}
    />
  );
};

export default UserFilterInput; 